import React from 'react'
import { NOTIFICATION_TYPES } from '../../consts'
import NotificationWarningIcon from '../../assets/svgs/notification-warning-icon.svg'
import NotificationErrorIcon from '../../assets/svgs/notification-error-icon.svg'
import NotificationSuccessIcon from '../../assets/svgs/notification-sucess-icon.svg'
import CloseIcon from '../../assets/svgs/close-icon.svg'
import './notification.scss'
import ButtonBase from '../ButtonBase'
import PropTypes from 'prop-types'
import useToggle from '../../hooks/useToggle'
import ArrowIcon from '../../assets/svgs/arrow-right.svg'

const { SUCCESS, WARNING, ERROR, INFO, WARNING_ERROR } = NOTIFICATION_TYPES

/** Notification  */
const Notification = ({ children, className, variant, onRemove, expandable, expandedDescription }) => {
  const [isExpanded, toggleExpand] = useToggle()
  return (<div
    className={`Suc-notification-widget ${className} Suc-${variant?.toLowerCase()}-notification`}>
    <div className="Suc-top">
      <div className='Suc-notification-icon'>
        {(variant === WARNING || variant === INFO || variant === WARNING_ERROR) && <NotificationWarningIcon/>}
        {variant === ERROR && <NotificationErrorIcon/>}
        {variant === SUCCESS && <NotificationSuccessIcon/>}
      </div>
      <div className='Suc-notification-content'>
        <div className={`Suc-notification-text ${expandable ? 'Suc-ellipsis' : ''}`}>{children}</div>
        {expandable && <ButtonBase className={'Suc-show-more'} onClick={toggleExpand}>
          <span className={'Suc-text'}>Show {isExpanded ? 'less' : 'more'}</span>
          <ArrowIcon className={`Suc-caret-icon ${isExpanded ? '' : 'Suc-down'}`}/>
        </ButtonBase>}
      </div>
      {onRemove && <ButtonBase className='Suc-remove-notification' onClick={onRemove}><CloseIcon/></ButtonBase>}
    </div>
    {isExpanded && <div className="Suc-bottom">
      {expandedDescription}
    </div>}
  </div>)
}
Notification.propTypes = {
  /** variant of notification */
  variant: PropTypes.oneOf([SUCCESS, WARNING, ERROR, INFO, WARNING_ERROR]),
  /** custom className */
  className: PropTypes.string,
  /** notification text */
  children: PropTypes.node,
  /** should be an expandable notification */
  expandable: PropTypes.bool,
  /** if it is expandable, what should be the description */
  expandedDescription: PropTypes.node
}

Notification.defaultProps = {
  variant: 'SUCCESS',
  className: '',
  expandable: false
}

export default Notification
